// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cardphoto {
  width: calc(33.33% - 10px);
  margin-bottom: 10px;
  margin-right: 10px;
  padding: 0px;
  background-color: #a0b5bf;
  cursor: pointer;
}

.cardphoto img {
  height: 200px;
  width: auto;
}

.cardphoto .card-text {
  font-size: 10px;
  color: #000;
}

.cardphoto .card-body {
  padding: 0.5rem;
}

.cuadrophotos {
  margin-left: 5px;
}

.tablareportes {
  border: 1px solid #000;
}

.tablareportes td,
th {
  border: 1px solid #c4c4c4;
}

.informacionContratoReporteResponsive {
  display: none;
}

/* Comparaciones */
.comparision {
  display: flex;
  flex-direction: column;
}

.comparision h3 {
  margin-bottom: 40px;
}

.infoAditionalBody {
  height: auto;

}

.infoAditionalBody p {
  margin-bottom: 0;
  font-size: 10px;
}

.comparision .comparisionImgs {
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
}

.comparision-item {
  margin-bottom: 20px;
}

.cardphotoComparative {
  position: relative;
  display: inline-block;
  width: calc(40% - 10px);
  margin-bottom: 20px;
  cursor: pointer;

}

.cardphotoComparative img {
  display: block;
  width: 100%;
  height: 200px;
  border-radius: 8px;
}

.cardphotoComparative::before,
.cardphotoComparative::after {
  content: '';
  position: absolute;
  top: 1px;
  left: 1px;
  right: 1px;
  bottom: 1px;
  border: 2px solid;
  border-radius: 8px;
  opacity: 0;
  animation: pulse 2s infinite;
}


.cardphotoComparative.border-green::before,
.cardphotoComparative.border-green::after {
  border-color: green;
}

.cardphotoComparative.border-yellow::before,
.cardphotoComparative.border-yellow::after {
  border-color: yellow;
}

.cardphotoComparative.border-red::before,
.cardphotoComparative.border-red::after {
  border-color: red;
}

.cardphotoComparative::before {
  animation-delay: 0s;
}

.cardphotoComparative::after {
  animation-delay: 1s;
}

.comparision .comparisionImgs {
  margin-top: 12px;
}

.comparision .comparisionResults {
  margin-top: 40px;
  margin-bottom: 30px;
}

/* Comparaciones */
.overlay {
  position: fixed;
  /* Fija el overlay en la pantalla */
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.02) !important;
  /* Fondo semi-transparente */
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10002;
  /* Se muestra sobre otros elementos */
}

.overlay-content {
  max-width: 90vw;
  /* Máximo 90% del ancho de la pantalla */

  /* Máximo 90% del alto de la pantalla */
  background-color: antiquewhite;
  padding: 12px;
  border-radius: 4px;
  /* Opcional: centrar la imagen dentro del contenedor */
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Estilo base para la imagen */
.overlay-content img {
  display: block;
  object-fit: contain;
  /* Mantiene proporción */
}

/* IMAGEN HORIZONTAL */
.overlay-content img.horizontal {
  /* Ocupa casi todo el ancho, sin forzar la altura */
  width: 100%;
  height: 90vh;
  max-height: 90vh;
}

/* IMAGEN VERTICAL */
.overlay-content img.vertical {
  /* Ocupa casi toda la altura, sin forzar el ancho */
  height: 90vh;
  width: auto;
  max-width: 90vw;
}




@keyframes pulse {
  0% {
    opacity: 0;
    transform: scale(0.95);
  }

  50% {
    opacity: 1;
    transform: scale(1.1);
  }

  100% {
    opacity: 0;
    transform: scale(1.25);
  }
}

/* .tablaaaa {
  width: 100%;
  overflow-x: auto;
  transform: translateX(10px);
}

/* Ensure the table adjusts to the container's width */
/* .tablePadre {
  width: 100%;  
  min-width: 700px;
  border-collapse: collapse;
} */


@media (max-width: 768px) {

  .cardphotoComparative {
    position: relative;
    display: inline-block;
    width: 100% !important;
    /* Por defecto, en móviles: 100% */
    margin-bottom: 20px;
    cursor: pointer;
  }

  .informacionContratoReporte {
    display: flex;
    flex-direction: column;
  }

  .tablaaaa {
    overflow-x: auto;
    /* Ensures the table can scroll horizontally */
  }

  .tablePadre {
    width: 100%;
    font-size: 5px
      /* Table takes full width */
  }

  .staticMapsControl {
    display: flex;
    flex-direction: column;

  }

  .imgUltimoPuntoControl,
  .imgUltimoRecorrido {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .imgUltimoPuntoControl img {
    width: 100%;

  }

  .imgUltimoRecorrido img {
    width: 100%;

  }

  .cuadrophotos {
    margin-left: 5px;
    display: flex;
    flex-direction: row;
  }

  .cardphoto {
    width: 100%;
  }

  .comparision {
    display: flex;
    flex-direction: column;
  }

  .comparision .comparisionImgs {
    display: flex;
    flex-direction: column;
    gap: 40px;
  }

  .comparision .comparisionImgs .cardphotoComparative {
    width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/Pages/Css/reporteservicio.css"],"names":[],"mappings":"AAAA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;;AAEd;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;;AAEjB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,aAAa;EACb,kBAAkB;AACpB;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,UAAU;EACV,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,4BAA4B;AAC9B;;;AAGA;;EAEE,mBAAmB;AACrB;;AAEA;;EAEE,oBAAoB;AACtB;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,kBAAkB;AAClB;EACE,eAAe;EACf,mCAAmC;EACnC,MAAM;EACN,OAAO;EACP,YAAY;EACZ,aAAa;EACb,gDAAgD;EAChD,4BAA4B;EAC5B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,qCAAqC;AACvC;;AAEA;EACE,eAAe;EACf,wCAAwC;;EAExC,uCAAuC;EACvC,8BAA8B;EAC9B,aAAa;EACb,kBAAkB;EAClB,sDAAsD;EACtD,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,+BAA+B;AAC/B;EACE,cAAc;EACd,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA,sBAAsB;AACtB;EACE,mDAAmD;EACnD,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA,oBAAoB;AACpB;EACE,mDAAmD;EACnD,YAAY;EACZ,WAAW;EACX,eAAe;AACjB;;;;;AAKA;EACE;IACE,UAAU;IACV,sBAAsB;EACxB;;EAEA;IACE,UAAU;IACV,qBAAqB;EACvB;;EAEA;IACE,UAAU;IACV,sBAAsB;EACxB;AACF;;AAEA;;;;;;sDAMsD;AACtD;;;;GAIG;;;AAGH;;EAEE;IACE,kBAAkB;IAClB,qBAAqB;IACrB,sBAAsB;IACtB,kCAAkC;IAClC,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,sBAAsB;EACxB;;EAEA;IACE,gBAAgB;IAChB,8CAA8C;EAChD;;EAEA;IACE,WAAW;IACX,aAAa;MACX,2BAA2B;EAC/B;;EAEA;IACE,aAAa;IACb,sBAAsB;;EAExB;;EAEA;;IAEE,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,WAAW;;EAEb;;EAEA;IACE,WAAW;;EAEb;;EAEA;IACE,gBAAgB;IAChB,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,aAAa;IACb,sBAAsB;EACxB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,WAAW;EACb;AACF","sourcesContent":[".cardphoto {\n  width: calc(33.33% - 10px);\n  margin-bottom: 10px;\n  margin-right: 10px;\n  padding: 0px;\n  background-color: #a0b5bf;\n  cursor: pointer;\n}\n\n.cardphoto img {\n  height: 200px;\n  width: auto;\n}\n\n.cardphoto .card-text {\n  font-size: 10px;\n  color: #000;\n}\n\n.cardphoto .card-body {\n  padding: 0.5rem;\n}\n\n.cuadrophotos {\n  margin-left: 5px;\n}\n\n.tablareportes {\n  border: 1px solid #000;\n}\n\n.tablareportes td,\nth {\n  border: 1px solid #c4c4c4;\n}\n\n.informacionContratoReporteResponsive {\n  display: none;\n}\n\n/* Comparaciones */\n.comparision {\n  display: flex;\n  flex-direction: column;\n}\n\n.comparision h3 {\n  margin-bottom: 40px;\n}\n\n.infoAditionalBody {\n  height: auto;\n\n}\n\n.infoAditionalBody p {\n  margin-bottom: 0;\n  font-size: 10px;\n}\n\n.comparision .comparisionImgs {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-evenly;\n}\n\n.comparision-item {\n  margin-bottom: 20px;\n}\n\n.cardphotoComparative {\n  position: relative;\n  display: inline-block;\n  width: calc(40% - 10px);\n  margin-bottom: 20px;\n  cursor: pointer;\n\n}\n\n.cardphotoComparative img {\n  display: block;\n  width: 100%;\n  height: 200px;\n  border-radius: 8px;\n}\n\n.cardphotoComparative::before,\n.cardphotoComparative::after {\n  content: '';\n  position: absolute;\n  top: 1px;\n  left: 1px;\n  right: 1px;\n  bottom: 1px;\n  border: 2px solid;\n  border-radius: 8px;\n  opacity: 0;\n  animation: pulse 2s infinite;\n}\n\n\n.cardphotoComparative.border-green::before,\n.cardphotoComparative.border-green::after {\n  border-color: green;\n}\n\n.cardphotoComparative.border-yellow::before,\n.cardphotoComparative.border-yellow::after {\n  border-color: yellow;\n}\n\n.cardphotoComparative.border-red::before,\n.cardphotoComparative.border-red::after {\n  border-color: red;\n}\n\n.cardphotoComparative::before {\n  animation-delay: 0s;\n}\n\n.cardphotoComparative::after {\n  animation-delay: 1s;\n}\n\n.comparision .comparisionImgs {\n  margin-top: 12px;\n}\n\n.comparision .comparisionResults {\n  margin-top: 40px;\n  margin-bottom: 30px;\n}\n\n/* Comparaciones */\n.overlay {\n  position: fixed;\n  /* Fija el overlay en la pantalla */\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n  background-color: rgba(0, 0, 0, 0.02) !important;\n  /* Fondo semi-transparente */\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 10002;\n  /* Se muestra sobre otros elementos */\n}\n\n.overlay-content {\n  max-width: 90vw;\n  /* Máximo 90% del ancho de la pantalla */\n\n  /* Máximo 90% del alto de la pantalla */\n  background-color: antiquewhite;\n  padding: 12px;\n  border-radius: 4px;\n  /* Opcional: centrar la imagen dentro del contenedor */\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n/* Estilo base para la imagen */\n.overlay-content img {\n  display: block;\n  object-fit: contain;\n  /* Mantiene proporción */\n}\n\n/* IMAGEN HORIZONTAL */\n.overlay-content img.horizontal {\n  /* Ocupa casi todo el ancho, sin forzar la altura */\n  width: 100%;\n  height: 90vh;\n  max-height: 90vh;\n}\n\n/* IMAGEN VERTICAL */\n.overlay-content img.vertical {\n  /* Ocupa casi toda la altura, sin forzar el ancho */\n  height: 90vh;\n  width: auto;\n  max-width: 90vw;\n}\n\n\n\n\n@keyframes pulse {\n  0% {\n    opacity: 0;\n    transform: scale(0.95);\n  }\n\n  50% {\n    opacity: 1;\n    transform: scale(1.1);\n  }\n\n  100% {\n    opacity: 0;\n    transform: scale(1.25);\n  }\n}\n\n/* .tablaaaa {\n  width: 100%;\n  overflow-x: auto;\n  transform: translateX(10px);\n}\n\n/* Ensure the table adjusts to the container's width */\n/* .tablePadre {\n  width: 100%;  \n  min-width: 700px;\n  border-collapse: collapse;\n} */\n\n\n@media (max-width: 768px) {\n\n  .cardphotoComparative {\n    position: relative;\n    display: inline-block;\n    width: 100% !important;\n    /* Por defecto, en móviles: 100% */\n    margin-bottom: 20px;\n    cursor: pointer;\n  }\n\n  .informacionContratoReporte {\n    display: flex;\n    flex-direction: column;\n  }\n\n  .tablaaaa {\n    overflow-x: auto;\n    /* Ensures the table can scroll horizontally */\n  }\n\n  .tablePadre {\n    width: 100%;\n    font-size: 5px\n      /* Table takes full width */\n  }\n\n  .staticMapsControl {\n    display: flex;\n    flex-direction: column;\n\n  }\n\n  .imgUltimoPuntoControl,\n  .imgUltimoRecorrido {\n    width: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n\n  .imgUltimoPuntoControl img {\n    width: 100%;\n\n  }\n\n  .imgUltimoRecorrido img {\n    width: 100%;\n\n  }\n\n  .cuadrophotos {\n    margin-left: 5px;\n    display: flex;\n    flex-direction: row;\n  }\n\n  .cardphoto {\n    width: 100%;\n  }\n\n  .comparision {\n    display: flex;\n    flex-direction: column;\n  }\n\n  .comparision .comparisionImgs {\n    display: flex;\n    flex-direction: column;\n    gap: 40px;\n  }\n\n  .comparision .comparisionImgs .cardphotoComparative {\n    width: 100%;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
